
const tabulator = (state = {type: 'INITIAL_STATE', three: []}, action) => {
  switch (action.type) {
    case 'ADD_TABULATOR':
    return {
        ...state,
        type: "ADD_TABULATOR",
        three: action.three,
      }
    default:
    return state
  }
}

export default tabulator